<template>
  <div>
    <van-cell-group title="筛选项">
    <van-field
      readonly
      clickable
      label="年份"
      :value="yearvalue"
      placeholder="选择年份"
      @click="showyear = true"
    />
    <van-field
      readonly
      clickable
      label="工作年限"
      :value="workyearsvalue"
      placeholder="工作年限"
      @click="showworkyears = true"
    />
    <van-field
      readonly
      clickable
      label="学历要求"
      :value="educationvalue"
      placeholder="学历要求"
      @click="showeducation = true"
    />
    <van-field
      readonly
      clickable
      label="考试类别"
      :value="positiontypevalue"
      placeholder="考试类别"
      @click="showpositiontype = true"
    />
    <van-field
      readonly
      clickable
      label="专业考试"
      :value="specialtyexamvalue"
      placeholder="专业考试"
      @click="showspecialtyexam = true"
    />
    </van-cell-group>
<div style="padding-left: 1.25rem;padding-right: 1.25rem;margin-top: 1.25rem;"><van-button round  type="danger" size="large" @click="route2list()">查询</van-button></div>
    <van-popup v-model="showyear" round position="bottom">
      <van-picker
        show-toolbar
        :columns="year_Columns"
        :default-index="0"
        @cancel="showyear = false"
        @confirm="onConfirmyear"
      />
    </van-popup>
    <van-popup v-model="showworkyears" round position="bottom">
      <van-picker
        show-toolbar
        :columns="workyears_Columns"
        :default-index="0"
        @cancel="showworkyears = false"
        @confirm="onConfirmworkyears"
      />
    </van-popup>
    <van-popup v-model="showeducation" round position="bottom">
      <van-picker
        show-toolbar
        :columns="education_Columns"
        :default-index="0"
        @cancel="showeducation = false"
        @confirm="onConfirmeducation"
      />
    </van-popup>
    <van-popup v-model="showpositiontype" round position="bottom">
      <van-picker
        show-toolbar
        :columns="positiontype_Columns"
        :default-index="0"
        @cancel="showpositiontype = false"
        @confirm="onConfirmpositiontype"
      />
    </van-popup>
    <van-popup v-model="showspecialtyexam" round position="bottom">
      <van-picker
        show-toolbar
        :columns="specialtyexam_Columns"
        :default-index="0"
        @cancel="showspecialtyexam = false"
        @confirm="onConfirmspecialtyexam"
      />
    </van-popup>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        value: '',
        yearvalue: '2025',
        workyearsvalue: '全部',
        educationvalue: '全部',
        positiontypevalue: '全部',
        specialtyexamvalue: '全部',
        showPicker: false,
        showyear:false,
        showworkyears:false,
        showeducation:false,
        showpositiontype:false,
        showspecialtyexam:false,
        year_Columns: [
			    '2025',
                '2024',
                '2023',
        		'2022',
          ],
          workyears_Columns: [
                   '全部',
           				'不限',
           				'二年',
                   '三年',
                   '四年',
                   '五年以上'
             ],
           education_Columns: [
                     '全部',
             				'大专及以上',
             				'本科',
                     '本科及以上',
                     '硕士',
                     '硕士及以上',
                     '博士'
               ],
           positiontype_Columns: [
                     '全部',
             				'公务员(A类)',
             				'参公(A类)',
                     '公务员(B类)',
                     '参公(B类)',
                     '食药监基层执法',
                     '动卫监基层执法',
                     '乡镇街道定向',
                     '医务类特殊职位',
                     '公安系统特警',
                     '残疾人专项'
               ],
           specialtyexam_Columns: [
                     '全部',
                     '综合管理',
                     '城市建设管理',
                     '经济管理',
                     '财务管理',
                     '信息管理',
                     '农村建设管理'
               ],
      };
    },
    methods: {
      onConfirm(value) {
        this.value = value;
        this.showPicker = false;
      },
      onConfirmyear(value) {
        this.yearvalue = value;
        this.showyear = false;
      },
      onConfirmworkyears(value) {
        this.workyearsvalue = value;
        this.showworkyears = false;
      },
      onConfirmeducation(value) {
        this.educationvalue = value;
        this.showeducation = false;
      },
      onConfirmpositiontype(value) {
        this.positiontypevalue = value;
        this.showpositiontype = false;
      },
      onConfirmspecialtyexam(value) {
        this.specialtyexamvalue = value;
        this.showspecialtyexam = false;
      },
	  route2list(){
		this.$router.push({
			name: 'position_list', 
			query: { position_zyear: this.yearvalue,position_workYears: this.workyearsvalue,position_education: this.educationvalue,position_positionType: this.positiontypevalue,position_specialtyExam: this.specialtyexamvalue }}); 
	  },

    },
  };
</script>

<style>
</style>
